import {motion} from "framer-motion";
import React from "react";
import AboutFeatures from "./sections/AboutFeatures";
import ContactSection from "./sections/ContactSection";
import HeroSection from "./sections/HeroSection";
import HowItWorksSection from "./sections/HowItWorksSection";
import ServicesSection from "./sections/ServicesSection";
import TherapySection from "./sections/TherapySection";
import TourBanner from "./sections/TourBanner";

const leftAnim = {
    initial: {opacity: 0, x: -60},
    whileInView: {opacity: 1, x: 0},
    viewport: {once: true, amount: 0.2},
    transition: {duration: 0.8, ease: "easeInOut"},
};
const rightAnim = {
    initial: {opacity: 0, x: 60},
    whileInView: {opacity: 1, x: 0},
    viewport: {once: true, amount: 0.2},
    transition: {duration: 0.8, ease: "easeInOut"},
};

const HomePage = () => {
    return (
        <div className="bg-white w-full relative">
            <div className="absolute inset-0 overflow-hidden">
                <motion.div
                    className="absolute top-10 left-10 w-20 h-20 bg-pink-100 rounded-full opacity-30 pointer-events-none"
                    animate={{
                        x: [0, 50, 0],
                        y: [0, 30, 0],
                        scale: [1, 1.1, 1],
                    }}
                    transition={{duration: 8, repeat: Infinity, ease: "easeInOut"}}
                />
                <motion.div
                    className="absolute top-1/4 right-20 w-16 h-16 bg-blue-100 rounded-full opacity-20 pointer-events-none"
                    animate={{
                        x: [0, -40, 0],
                        y: [0, 40, 0],
                    }}
                    transition={{duration: 12, repeat: Infinity, ease: "easeInOut"}}
                />
                <motion.div
                    className="absolute bottom-20 left-1/3 w-12 h-12 bg-green-100 opacity-25 pointer-events-none"
                    animate={{
                        rotate: [0, 360],
                        x: [0, 20, 0],
                    }}
                    transition={{duration: 15, repeat: Infinity, ease: "linear"}}
                />
                <motion.div
                    className="absolute top-1/2 left-1/4 w-24 h-24 bg-yellow-100 rounded-full opacity-15 pointer-events-none"
                    animate={{
                        x: [0, 60, 0],
                        y: [0, -20, 0],
                    }}
                    transition={{duration: 10, repeat: Infinity, ease: "easeInOut"}}
                />
            </div>
            <motion.div {...leftAnim}>
                <HeroSection/>
            </motion.div>
            <motion.div {...rightAnim}>
                <TourBanner/>
            </motion.div>
            <motion.div {...leftAnim}>
                <AboutFeatures/>
            </motion.div>
            <motion.div {...rightAnim}>
                <ServicesSection/>
            </motion.div>
            <motion.div {...leftAnim}>
                <TherapySection/>
            </motion.div>
            <motion.div {...rightAnim}>
                <HowItWorksSection/>
            </motion.div>
            <motion.div {...leftAnim}>
                <ContactSection/>
            </motion.div>
        </div>
    );
};

export default HomePage;
